<div
  class="scrollable-container"
  cdkScrollable
  cdkDropList
  (cdkDropListDropped)="drop($event)"
>
  <div class="options-list">
    <div class="d-flex align-items-center select-all-container">
      <label class="d-flex align-items-center pointer-label select-all-text">
        <input
          type="checkbox"
          [checked]="isAllSelected"
          (change)="toggleSelectAll($event)"
          class="d-none"
        />
        <img
          src="/assets/media/icons/checkbox-{{
            isAllSelected ? 'checked' : 'unchecked'
          }}.svg"
          alt="Select All checkbox icon"
        />
        <div class="ms-2">Select All</div>
      </label>
    </div>

    @for (option of columnOptions; let i = $index; track option.label) {
      <div
        cdkDrag
        class="drag-wrapper drag-box"
        [cdkDragDisabled]="option?.disabled"
      >
        <img
          src="/assets/media/icons/drag-icon.svg"
          alt="drag icon"
          [class.hidden]="option?.disabled"
        />
        <div class="d-flex align-items-center w-100 justify-content-between">
          <div class="d-flex align-items-center">
            <label class="d-flex align-items-center ms-3 pointer-label">
              <input
                type="checkbox"
                [(ngModel)]="option.selected"
                (change)="onSelectionChange()"
                class="d-none"
              />
              @if (option.selected && !option?.disabled) {
                <img
                  src="/assets/media/icons/checkbox-checked.svg"
                  alt="Checked checkbox icon"
                />
              } @else {
                @if (!option?.disabled && !option?.selected) {
                  <img
                    src="/assets/media/icons/checkbox-unchecked.svg"
                    alt="Unchecked checkbox icon"
                  />
                }
                @if (option?.disabled && !option.selected) {
                  <img
                    src="/assets/media/icons/checkbox-empty.svg"
                    alt="Unchecked checkbox icon"
                  />
                }
              }

              @if (option?.disabled && option?.selected) {
                <img
                  src="/assets/media/icons/checkbox-disabled.svg"
                  alt="icon"
                />
              }
            </label>
            <div class="ms-2">{{ option.label }}</div>
          </div>

          <label class="d-flex align-items-center ms-3 pointer-label">
            <input
              type="checkbox"
              [ngModel]="option.locked"
              class="d-none"
              (ngModelChange)="onLockChange(i)"
            />
            @if (!option.locked && !option?.disabled) {
              <img src="/assets/media/icons/unlock-icon.svg" alt="icon" />
            } @else {
              @if (!option?.disabled) {
                <img src="/assets/media/icons/locked.svg" alt="icon" />
              }
            }
            <ng-template #locked>
              @if (!option?.disabled) {
                <img src="/assets/media/icons/locked.svg" alt="icon" />
              }
            </ng-template>
            @if (option?.disabled) {
              <img src="/assets/media/icons/lock-disabled.svg" alt="icon" />
            }
          </label>
        </div>
      </div>
    }
  </div>
</div>
